/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.allOptionsSelectedCheck();
      this.oneLessOptionsSelectedCheck();
      this.updateAvailability();
      this.updateAddToCartButton();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }
    
    // returns true if all options are selected by customer
    allOptionsSelectedCheck(){
      let allOptionsSelected = true;
      this.optionSelectors.forEach((selector) => {
        
        if (selector.dataset.selectorType === 'dropdown') {
          
          if(selector.querySelector('.custom-select__btn').querySelector('span.text-start').innerHTML === "Please select"){
            allOptionsSelected = false;
          }
        } else {
          if(!selector.querySelector('input:checked').value == undefined){
            allOptionsSelected = false;
          }
        }
      });

      return allOptionsSelected;
    }

    // returns true if one less options are selected by customer
    oneLessOptionsSelectedCheck(){
      let allOptionsSelected = false;
      let noOfSelectedOptions = 0;
      let totalOptions = this.optionSelectors.length; 
      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          if(selector.querySelector('.custom-select__btn').querySelector('span.text-start').innerHTML === "Please select"){
            allOptionsSelected = false;
          }else{
            ++noOfSelectedOptions;
          }
        } else {
          if(!selector.querySelector('input:checked').value == undefined){
            allOptionsSelected = false;
          }
        }
      });

      let oneLessOptionsSelected = false;
      
      if(totalOptions - noOfSelectedOptions == 1){
        oneLessOptionsSelected = true;
      }

      return oneLessOptionsSelected;
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      let allOptionsSelected = this.allOptionsSelectedCheck();
      if(this.closest('quick-add-drawer') && !this.productForm){
        let formWrapper = this.closest('quick-add-drawer').querySelector('footer product-form');
        
        let formInterval = setInterval(function(){
          let form = formWrapper.querySelector('form');
          if(form){
            this.productForm = form;
            if (!this.productForm) return;

              this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
              const variantAvailable = this.variant && this.variant.available;
              let unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
              unavailableStr = this.addBtn.dataset.availableLabel;
              
              if(allOptionsSelected && variantAvailable){
                unavailableStr = "Add to cart";
              }else{
                unavailableStr = "Select an option";
              }
              this.addBtn.disabled = !variantAvailable;
              this.addBtn.textContent = variantAvailable
                ? this.addBtn.dataset.addToCartText
                : unavailableStr;
              if(document.querySelector('.card__buttons > a')){
                document.querySelector('.card__buttons > a').innerHTML = this.addBtn.textContent;  
              }
            clearInterval(formInterval);
          }
        }, 300);
      }

      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      let unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      unavailableStr = this.addBtn.dataset.availableLabel;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
      if(document.querySelector('.card__buttons > a')){
        document.querySelector('.card__buttons > a').innerHTML = this.addBtn.textContent;  
      }
      
      
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      
      if (this.dataset.showAvailability === 'false') return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        let allOptionsSelected = this.allOptionsSelectedCheck();
        if(this.closest('quick-add-drawer') && !this.productForm){
          let formWrapper = this.closest('quick-add-drawer').querySelector('footer product-form');

          let formInterval = setInterval(function(){
            let form = formWrapper.querySelector('form');
            if(form){
              this.productForm = form;
              this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
              
              if(allOptionsSelected && available){
                this.addBtn.dataset.availableLabel = "Add to cart";
              }else{
                this.addBtn.dataset.availableLabel = "Select an option";
              }
              clearInterval(formInterval);
            }
          }, 300);
        }
        if(this.productForm){
          this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
        }
        
        let option_text = el.querySelector('span').innerHTML;
       
        if(option_text != "Please select"){
          let text = soldout ? theme.strings.noStock : theme.strings.noVariant;

          
          let oneLessOptionsSelected = this.oneLessOptionsSelectedCheck();
          let optionsList = el.closest('ul');
          let selectorIndex = optionsList.getAttribute('data-index');
          let hasSelectedOption = false;
          let selectedOptionText = "Please select";

          if(optionsList.querySelector('[aria-selected="true"]')){
            selectedOptionText = optionsList.querySelector('[aria-selected="true"] span').innerHTML;
          }

          if(selectedOptionText != "Please select"){
            hasSelectedOption = true;
          }
          
          el.classList.toggle('is-unavailable', !available);

          if (el.classList.contains('custom-select__option')) {
            const em = el.querySelector('em');

            // let preAvailability = this.checkPreAvailability(option_text, selectorIndex);
            
            if (em) {
              em.hidden = available;
              el.style.display = 'flex';
              el.setAttribute('data-display', 'visible');
              
              
              if(oneLessOptionsSelected && !available && !hasSelectedOption){
                el.style.display = 'none';
                el.setAttribute('data-display', 'hidden');
              }

              if(allOptionsSelected && !available){
                el.style.display = 'none';
                el.setAttribute('data-display', 'hidden');
              }
            }

            let hidden_options = optionsList.querySelectorAll('[data-display="hidden"]').length;
            let actual_options = optionsList.querySelectorAll('li').length - 1;
          
            if(this.addBtn){
              if(allOptionsSelected && available){
                this.addBtn.dataset.availableLabel = "Add to cart";
              }else{
                this.addBtn.dataset.availableLabel = "Select an option";
              }
  
              if(hidden_options == actual_options){
                this.addBtn.dataset.availableLabel = "Unavailable";
              }
            }
           
            

            if (!available) {
              if (em) {
                em.textContent = text;
              } else {
                el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
              }
            }
            
          } else if (!available) {
            el.nextElementSibling.title = text;
           
          } else {
            el.nextElementSibling.removeAttribute('title');
            
          }
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll('.js-option').forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.dataset.value === variant.options[selectorIndex];
              }
              return opt.value === variant.options[selectorIndex];
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      this.sku_mobile = this.section.querySelector('.product-sku-mobile__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      if(this.sku_mobile){
        this.sku_mobile.textContent = skuAvailable ? this.variant.sku : '';
        this.sku_mobile.parentNode.hidden = !skuAvailable;
      }
      this.sku.parentNode.hidden = !skuAvailable;      
      
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }

    recursiveAvailabilityCheck(selectedOptions){
      if(selectedOptions.includes('Please select')){
        for(var j=0;j<this.optionSelectors.length;++j){
          let selector = this.optionSelectors[j];
          let selectorIndex = j;
          if (selector.dataset.selectorType === 'dropdown') {
            if(selectedOptions[selectorIndex] == 'Please select'){
              let otherOptions = selector.querySelectorAll('.custom-select__option');
              for(var i=0 ; i < otherOptions.length ; ++i){
                let otherOptionText = otherOptions[i].querySelector('span').innerHTML;
                if(otherOptionText != 'Please select'){
                  selectedOptions[selectorIndex] = otherOptionText;
                    return this.recursiveAvailabilityCheck(selectedOptions);
                }
              }
            
            }
          }
        }
        
      }else{
          let variant = this.data.product.variants.find(
            (v) => v.options.every((val, index) => val === selectedOptions[index])
          );

          if(variant){
            return true;
          }else{
            return false;
          }
      }
      
    }

    /**
     * Get selected variant data.
     * @returns {?object}Variant object, or null if one is not selected.
     */
    checkPreAvailability(option_text, index) {
      let available = true;
      const selectedOptions = this.getSelectedOptions();
      let totalNotSelected = selectedOptions.filter((v) =>  v === "Please select").length;
      if(totalNotSelected != selectedOptions.length){
        if(selectedOptions[index] == "Please select"){
          selectedOptions[index] = option_text.trim();
          available = this.recursiveAvailabilityCheck(selectedOptions);
        }
      }
    
      return available;
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
